// @custom — Visitor tracker: fires a page view event on every route change.
//
// Renders nothing — its side effect is calling trackPageView() for the
// current URL on mount and on every location change. Mounted alongside
// the Toaster so that every page (public and app) is covered.
//
// The @system Analytics component handles consent-gated third-party scripts
// (GA4 / GTM). This tracker runs without consent because it only sends
// first-party data to the product's own POST /analytics/pageview endpoint
// and does not load any external script.

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '@/app/lib/@custom/analytics'

export default function VisitorTracker() {
  const location = useLocation()

  useEffect(() => {
    const path = location.pathname + location.search
    if (path) trackPageView(path)
  }, [location])

  return null
}